module.exports = __webpack_public_path__ + "static/media/mx_3x4.fc563797.svg";